'use strict'
import { request } from '../../plugins/http'

export default async (params) => {
    return await request.put('/grupoUsuarioAtendimento', params)
}